<!-- eslint-disable object-shorthand -->
<!-- eslint-disable func-names -->
<template>
  <highcharts
    style="height: 100%"
    :options="chartOptions"
  />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BarChart',
  props: {
    chartData: {
      type: Array,
      default: null,
    },
    chartInterval: {
      type: Array,
      default: null,
    },
    yAxisLabel: {
      type: String,
      default: '',
    },
    xAxisLabel: {
      type: String,
      default: '',
    },
    interval: {
      type: String,
      default: '',
    },
    peakLimit: {
      type: Number,
      default: null,
    },
    enableGrouping: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('layout', {
      darkMode: (state) => state.darkMode,
    }),
    labelStep() {
      // More label step on small display
      if (this.interval == 'quarter_hourly') {
        return (window.screen.width >= 991) ? 4 : 16;
      }
      if (this.interval == 'hourly') {
        return (window.screen.width >= 991) ? 1 : 4;
      }
      if (this.interval == 'daily') {
        return (window.screen.width >= 991) ? 1 : 7;
      }
      if (this.interval == 'monthly') {
        return (window.screen.width >= 991) ? 1 : 2;
      }
      return 8;
    },
    chartOptions() {
      return {
        chart: {
          type: 'column',
          backgroundColor: this.darkMode ? '#32394E' : '#fff',
          zoomType: 'x',
          panning: {
            enabled: true,
          },
          panKey: 'shift',
        },
        boost: {
          useGPUTranslations: true,
        },
        title: {
          text: ' ',
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          shared: true,
        },
        plotOptions: {
          column: {
            grouping: this.enableGrouping, // true (Column side to side) false (Column on top of each other)
            shadow: false,
            borderWidth: (window.screen.width >= 991) ? 1.0 : 0.2,
          },
          series: {
            pointPadding: 0,
            minPointLength: 1,
            dataGrouping: {
              enabled: true,
            },
            lineWidth: 1,
            states: {
              hover: {
                enabled: true,
                lineWidth: 1.5,
                // halo: {
                //   size: 9,
                //   attributes: {
                //     fill: '#000',
                //     'stroke-width': 2,
                //     stroke: '#235920',
                //   },
                // },
              },
              inactive: {
                enabled: false,
              },
            },
            column: {
              grouping: false,
              shadow: false,
            },
          },
        },
        xAxis: {
          title: {
            text: this.xAxisLabel,
            style: {
              color: this.darkMode ? '#fff' : '#666666',
            },
          },
          labels: {
            style: {
              color: this.darkMode ? '#fff' : '#666666',
            },
            step: this.labelStep,
            formatter() {
              const label = this.axis.defaultLabelFormatter.call(this);
              const formatedLabel = Number(label.toString().slice(0, 2));
              if (formatedLabel.toString() != 'NaN') {
                return formatedLabel;
              }
              return label;
            },
          },
          categories: this.chartInterval,
        },
        yAxis: {
          title: {
            text: this.yAxisLabel,
            style: {
              color: this.darkMode ? '#fff' : '#666666',
            },
          },
          labels: {
            style: {
              color: this.darkMode ? '#fff' : '#666666',
            },
          },
          plotLines: this.peakLimit ? [{
            // Warning Level
            color: '#BC250C',
            width: 0.7,
            value: 0.95 * this.peakLimit,
            zIndex: 5,
          }, {
            // Alert Level
            color: '#EDB908',
            width: 0.7,
            value: 0.90 * this.peakLimit,
            zIndex: 5,
          }] : [],
          gridLineColor: this.darkMode ? '#495166' : '#e6e6e6',
        },
        series: this.chartData,
      };
    },
  },
};
</script>
